import { create } from 'zustand'

interface SafeAreaState {
    showStatusBarCover: boolean
    statusBarColor: 'white' | 'black'
    setShowStatusBarCover: (show: boolean) => void
    setStatusBarColor: (color: 'white' | 'black') => void
}

/**
 * Store for managing safe area / status bar cover visibility and color
 * Used by layouts that want to go edge-to-edge (like onboarding)
 * to opt out of the default status bar cover, or change its color (like story viewer)
 */
export const useSafeAreaStore = create<SafeAreaState>((set) => ({
    showStatusBarCover: true,
    statusBarColor: 'white',
    setShowStatusBarCover: (show) => set({ showStatusBarCover: show }),
    setStatusBarColor: (color) => set({ statusBarColor: color }),
}))

